import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Fab from '@mui/material/Fab';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import LoadIcon from '@mui/icons-material/Autorenew';
import SuccessIcon from '@mui/icons-material/Check';
import { tokens } from '../theme';

interface LoaderProps {
  isLoading: boolean;
  isSuccess: boolean;
  loadingText?: string;
  successText?: string;
  errorText?: string;
}

const Loader = ({ isLoading, isSuccess, loadingText, successText, errorText }: LoaderProps) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const textWhileLoading = loadingText ?? "LOADING PHARMACY DATA...";
  const textOnSuccess = successText ?? "GREAT! PHARMACY DATA LOADED.";
  const textOnError = errorText ?? "ERROR! TRY AGAIN.";
  const FabSx = {
    ...(isLoading ? {
      bgcolor: colors.blueAccent[400]
    } : (isSuccess ? {
      bgcolor: colors.greenAccent[400]
    } : {
      bgcolor: colors.redAccent[400]
    })),
  };

  return (
    <Box
      display="flex"
      alignItems="center"
    >
      <Box 
        sx={{ 
          m: 1, 
          position: 'relative' 
        }}
      >
        <Fab
          aria-label="situation"
          color="primary"
          sx={FabSx}
          size="medium"
        >
          {isLoading ? <LoadIcon /> : (isSuccess ? <SuccessIcon /> : <ErrorIcon />)}
        </Fab>

        {isLoading && 
          <CircularProgress 
            size={60}
            sx={{
              color: colors.blueAccent[400],
              position: 'absolute',
              top: -6,
              left: -6,
              zIndex: 1
            }} 
            thickness={4.0}
          />
        }
      </Box>

      <Typography 
        variant="h6" 
        color={colors.grey[100]}
        sx={{
          ml: '7px'
        }}  
      >
        {isLoading ? textWhileLoading : (isSuccess ? textOnSuccess : textOnError)}
      </Typography>
    </Box>
  );
};

export default Loader;